import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetRewardStatusRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetRewardStatusResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getRewardStatus = (request: GetRewardStatusRequest, options?: CashRequestOptions) =>
  post<GetRewardStatusRequest, GetRewardStatusResponse>('/2.0/cash/get-reward-status', request, {
    ...options,
    rejectOnError: true,
  })
